import * as React from 'react';
import autobind from 'autobind-decorator';

import { DataTableView, ToolbarVisibility, Column } from 'src/core/ui/data-table.view';
import { DropdownView } from 'src/core/ui/dropdown.view';

interface ContractsServiceViewProps extends ComponentViewProps<ContractItem> {
	mode: ControlMode;
	dataService: DataSet<ContractServiceTypeItem>;
	createNew: () => any;
	serviceDataService: DataSet<ProductServiceTypeSummary>;
}

export class ContractsServiceView extends React.Component<ContractsServiceViewProps, any> {
	constructor(props) {
		super(props);
	}

	columns: Column[] = [
		{
			key: 'productServiceTypeDisplayName',
			dataIndex: 'productServiceTypeDisplayName',
			title: 'Service',
			editable: (text: string, record: ContractServiceTypeItem, index: number, isSelected: boolean) => {
				if (isSelected) {
					const options = this.props.serviceDataService != null
						? this.props.serviceDataService.items.slice()
						: [];
					return (
						<DropdownView
							label={null}
							disabled={this.props.mode == 'display'}
							model={record.productServiceTypeId}
							onChanged={newVal => {
								if (newVal != null) {
									record.productServiceTypeId = newVal.id;
									record.productServiceTypeDisplayName = newVal.displayName;
								} else {
									record.productServiceTypeId = null;
									record.productServiceTypeDisplayName = null;
								}
							}}
							options={options}
							keyField="id"
							textField="displayName"
						/>
					);
				}

				return record.productServiceTypeDisplayName || "";
			}
		}
	];

	@autobind
	private deleteServices(type: 'cost' | 'price', services: ContractServiceTypeItem[]) {
		let price: PriceItem = this.props.model.dynamicProperties[type];
		let todelete = price.elements.filter(x => services.some(e => e.productServiceTypeId == x.service))
		for (let del of todelete) {
			let indexcs = price.elements.findIndex(x => x.service == del.service);
			price.elements.splice(indexcs, 1);
		}
	}

	render() {
		if (this.props.model == null) {
			return null;
		}

		return (
			<DataTableView
				mode={this.props.mode}
				setBusy={this.props.setBusy}
				columns={this.columns}
				model={this.props.dataService}
				hideToolbar={ToolbarVisibility.hideSearch}
				createNewItem={this.props.createNew}
				afterDeleteItem={items => {
					for (const item of items) {
						this.props.model.services.splice(this.props.model.services.findIndex(e => e.id == item.id), 1);
					}
					this.deleteServices('cost', items);
					this.deleteServices('price', items);
				}}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/products/contract/form/parts/contract-service.view.tsx